import { Select } from '@mantine/core';
import { useFilterFormContext } from '@/pages/Statistics/StatisticsPage';

const FormSelectSex = () => {
  const form = useFilterFormContext();
  const isValidSex = (value: string | null): value is 'M' | 'F' | 'O' =>
    value === 'M' || value === 'F' || value === 'O';

  return (
    <Select
      label="Pohlaví"
      data={[
        { value: 'M', label: 'Muž' },
        { value: 'F', label: 'Žena' },
        { value: 'O', label: 'Ostatní' },
      ]}
      value={form.values.sex ?? null}
      allowDeselect
      clearable
      onChange={value => {
        form.setFieldValue('sex', isValidSex(value) ? value : undefined);
      }}
    />
  );
};

export default FormSelectSex;
